import { render, staticRenderFns } from "./ksjl.vue?vue&type=template&id=18bb0f96&scoped=true&"
import script from "./ksjl.vue?vue&type=script&lang=js&"
export * from "./ksjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb0f96",
  null
  
)

export default component.exports